import { Button } from '../../../../helbest';

const Footer = ({ submitClick }) => (
  <div className="page-delivery-footer">
    <Button onClick={submitClick}>تائید سفارش</Button>
  </div>
);

export default Footer;
